
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getTestResults",
      resolverType: "query",
      routePath: "/getTestResults",
      httpMethod: "POST",
    });
  